import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

export const getReportSetting = () => {
  const url = `${API_ROOT}/subproject/report-setting`
  return doGet(url)
}

export const searchReportSetting = (projectCode) => {
  const url = `${API_ROOT}/subproject/report-setting/${projectCode}`
  return doGet(url)
}

export const saveReportSetting = (projectCode, request) => {
  const url = `${API_ROOT}/subproject/report-setting/${projectCode}`
  return doPost(url, request)
}
